<script setup lang="ts">
import { StatusSourceType, useLiveStatusStore } from "@/stores";
import { mdiCancel } from "@mdi/js";
import { Badge, Icon, Tooltip } from "@soft-db/ui";
import { computed } from "vue";
import { useStateBadge } from "../status/composable/state-badge";

const props = defineProps<{
	sourceType: StatusSourceType;
	sourceId: string;
}>();

const { t } = useI18n();

const store = useLiveStatusStore();

const status = computed(() => store.statusState(props.sourceType, props.sourceId));

const stateBadge = useStateBadge(status);
</script>

<template>
	<Tooltip :tooltip="stateBadge?.text ?? t('common.notLinked')">
		<div class="cursor-default">
			<Badge v-if="stateBadge != null" class="rounded-full" size="xs" :color="stateBadge.color" />
			<Icon v-else class="text-base-content/30" size="sm" :d="mdiCancel" />
		</div>
	</Tooltip>
</template>
